'use client';

import { c as _c } from "react/compiler-runtime";
import PromoBanner, { type PromoBannerProps } from '@precis-digital/kurama/PromoBanner';
import { type ReactElement, type ReactNode } from 'react';
import { isThemeAssetSrc, type ThemeAssetSrc } from 'shared/assets/resolveThemeAsset';
import { useResolvedThemeAsset } from 'shared/assets/useResolvedThemeAsset';
type ThemedPromoBannerProps = Omit<PromoBannerProps, 'image'> & {
  /**
   * Same as Kurama `PromoBanner` `image`: a React node, or a theme asset
   * (string URL / static import under `public/assets/images`). Dark mode
   * selects the `.dark` sibling unless exempt.
   */
  image: ThemeAssetSrc | ReactNode;
};

/**
 * Drop-in theme-aware replacement for Kurama `PromoBanner` when `image` is a
 * static asset under `public/assets/images`. Keep `image={img}` or
 * `image={img.src}`.
 */
const ThemedPromoBanner = t0 => {
  const $ = _c(6);
  let image;
  let promoBannerProps;
  if ($[0] !== t0) {
    ({
      image,
      ...promoBannerProps
    } = t0);
    $[0] = t0;
    $[1] = image;
    $[2] = promoBannerProps;
  } else {
    image = $[1];
    promoBannerProps = $[2];
  }
  const themeAssetSrc = isThemeAssetSrc(image) ? image : undefined;
  const resolvedThemeAsset = useResolvedThemeAsset(themeAssetSrc);
  const resolvedImage = resolvedThemeAsset !== undefined ? resolvedThemeAsset : image as ReactNode;
  let t1;
  if ($[3] !== promoBannerProps || $[4] !== resolvedImage) {
    t1 = <PromoBanner {...promoBannerProps} image={resolvedImage} />;
    $[3] = promoBannerProps;
    $[4] = resolvedImage;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default ThemedPromoBanner;
export type { ThemedPromoBannerProps };